export default __webpack_public_path__ + "static/checklist-5416d61d33bab1b2fae2f8c0baa73014.png";